"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _Chevron = _interopRequireDefault(require("./Chevron"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

//
//  src/button/ChevronButton.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 8/7/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var DEFAULT_SIZE = 15;
var propDoc = {
  direction: {
    required: true,
    type: "\"left\" | \"right\" | \"down\" | \"up\"",
    description: "Direction of the arrow"
  },
  onClick: {
    required: true,
    type: "() => void",
    description: "Callback for when the button is clicked"
  },
  size: {
    required: false,
    defaultValue: "".concat(DEFAULT_SIZE),
    type: "number",
    description: "Size of the button"
  }
};
var demoProps = {
  direction: "right",
  onClick: function onClick() {},
  size: 16
};

var ChevronButton = function ChevronButton(props) {
  var className = props.className,
      onClick = props.onClick,
      style = props.style,
      direction = props.direction;
  var styles = useStylesheet(props);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style),
    style: style,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_Chevron["default"], {
    className: (0, _styling.css)(styles.img),
    direction: direction
  }));
};

ChevronButton.propDoc = propDoc;
ChevronButton.demoProps = demoProps;

var _default = (0, _mobxReact.observer)(ChevronButton);

exports["default"] = _default;

var useStylesheet = function useStylesheet(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? DEFAULT_SIZE : _props$size;

  var _useTheme = (0, _providers.useTheme)(),
      surface = _useTheme.surface;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        userSelect: "none",
        transition: "all 0.2s linear",
        opacity: 0.8,
        ":hover": {
          opacity: 1,
          backgroundColor: surface
        },
        borderRadius: "50%",
        width: 2.5 * size,
        height: 2.5 * size
      },
      img: {
        height: size
      }
    });
  }, [size, surface]);
};